// extracted by mini-css-extract-plugin
module.exports = {"base":"PromotionAlert_base__3xPfn","exclamation-mark":"PromotionAlert_exclamation-mark__AGL4Q"};